$( document ).ready(function() {
	'use strict';
    /*
    $(document).on('click','[data-zg-action="filter"]',function(e){
		console.log('test');
	});
    */
});    